import './card.sass';

export { default } from './card';
